import { ICustomerAddress } from "../../Models/Customer"
import { TPvcCenterAddress } from "../../Models/PVC"

const AddressCard = (props:{address: TPvcCenterAddress | ICustomerAddress, heading: string}) => {
    const { heading } = props
    const address = props.address || {}
    const { name, line1, line2, city, country, state } = address
    const { pincode, phone } = address as TPvcCenterAddress
    const { mobileNumber, zip } = address as ICustomerAddress
    const postal = pincode ? pincode : zip
    const mobile = phone ? phone : mobileNumber
    const street = line2 ? line1 + ', ' + line2 : line1
    const fullAddress = `${street},
    ${city}, ${state} - ${postal} ${country}
    `
  
    return (
      <div style={{ border: '1px solid silver', borderRadius: '10px',  color: 'var(--text_color_2)'  }}>
        <h3 style={{ color: 'var(--text_color_2)', background: '#f1f1f1', padding: '10px', borderRadius: '10px 10px 0 0' }}>{heading}</h3>
        <div style={{ display: 'flex', flexDirection: 'column', padding: '10px' }}>
          <h4>{name}</h4>
          <p>
            <span>
              {mobile}
            </span>
            <br />
            <span>
              {fullAddress}
            </span>
            <br />
          </p>
        </div>
      </div>
    )
  }

  export default AddressCard